import React from 'react';
import { MiniAppSettings } from '../../components/settings/miniapps/MiniAppSettings';
import { ChatInterface } from '../../components/chat/ChatInterface';
import { MiniAppModal } from '../../components/miniapps/MiniAppModal';

export default function MiniAppsSettings() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-white mb-2">Mini Apps settings</h2>
        <p className="text-gray-400">Activate and configure your chatbot's mini-apps</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Colonne de gauche - Contrôles */}
        <div className="w-full">
          <MiniAppSettings />
        </div>

        {/* Colonne de droite - Aperçu */}
        <div className="w-full">
          <div className="sticky top-24 h-[600px] bg-gray-900/50 rounded-xl border border-white/10 p-4">
            <div className="w-full h-full">
              <ChatInterface preview />
            </div>
          </div>
        </div>
      </div>

      <MiniAppModal />
    </div>
  );
}